export default (function (path) {
  return path ? "".concat(path, "/").replace(/\/+$/, '/') : '';
});